import React from 'react'
import { Row, Col } from 'react-bootstrap';
import poweredlogo from '../assets/images/powered-by-logo.png';



export default function Footer() {
  return (
    <>
      <footer className="footer mt-md-5 mt-4">
        <Row className="justify-content-between align-items-center">
          <Col lg={2} sm={4} className="text-sm-start text-center mb-1 mb-sm-0">
            <img src={poweredlogo} className="powered-logo" alt="Powered by SecurePay" />
          </Col>
          <Col lg={4} md={6} sm={8} className="text-sm-end text-center f-info">
            Our system uses SSL encryption technology, which is the same technology banks use to protect sensitive information.
          </Col>
        </Row>
      </footer>
    </>
  )
}
